(function () {
    String.prototype.format = String.prototype.f = function () {
        var s = this,
            i = arguments.length;

        while (i--) {
            s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
        }
        return s;
    };

    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };

    String.prototype.startsWith = function (str) {
        return this.slice(0, str.length) == str;
    };

    String.prototype.isNullOrWhitespace = function (input) {
        if (input === null || typeof input === 'undefined' || typeof input !== 'string') return true;
        return input.replace(/\s/g, '').length < 1;
    };

    String.prototype.fullName = function (name, middleName, surname) {
        var result = '';
        if (!String.prototype.isNullOrWhitespace(name)) {
            result = name;
        }

        if (!String.prototype.isNullOrWhitespace(middleName)) {
            if (!!result) {
                result = result + " " + middleName;
            }
            else 
            {
                result = middleName;
            }            
        }

        if (!String.prototype.isNullOrWhitespace(surname)) {
            if (!!result) {
                result = result + " " + surname;
            }
            else {
                result = surname;
            }
        }

        return result;

    };
})();